import { Waypoints } from 'lucide-react'

import { env } from '@/config/env'
import { cn } from '@/lib/utils'

/**
 * Brand lockup: a solid mark beside a two-line wordmark derived from the
 * configured app name (first word emphasised, remainder as a tracked subtitle).
 */
export function AppLogo({ className }: { className?: string }) {
  const [primary, ...rest] = env.appName.split(' ')
  const secondary = rest.join(' ')

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <span className="flex size-8 items-center justify-center rounded-md bg-primary text-primary-foreground">
        <Waypoints className="size-5" aria-hidden />
      </span>
      <span className="flex flex-col leading-none">
        <span className="text-sm font-bold tracking-tight uppercase">
          {primary ?? env.appName}
        </span>
        {secondary && (
          <span className="text-[10px] font-medium tracking-[0.2em] text-muted-foreground uppercase">
            {secondary}
          </span>
        )}
      </span>
    </div>
  )
}
